:where(button, a) {
  all: unset;
  display: inline-flex;
  align-items: center;
  user-select: none;
  touch-action: manipulation;
  cursor: pointer;
}

button:disabled {
  pointer-events: none;
}

*,
::after,
::before {
  box-sizing: border-box;
}

:host {
  /**
   * @prop --ch-accordion__chevron-size:
   * Specifies the box size of the chevron.
   * @default 0.875em
   */
  --ch-accordion__chevron-size: 0.875em;
  /**
   * @prop --ch-accordion__chevron-image-size:
   * Specifies the image size of the chevron.
   * @default 100%
   */
  --ch-accordion__chevron-image-size: 100%;
  /**
   * @prop --ch-accordion__chevron-color:
   * Specifies the color of the chevron.
   * @default 100%
   */
  --ch-accordion__chevron-color: currentColor;
  /**
   * @prop --ch-accordion-expand-collapse-duration
   * Specifies duration of the expand and collapse animation
   * @default 0ms
   */
  --ch-accordion-expand-collapse-duration: 0ms;
  /**
   * @prop --ch-accordion-expand-collapse-timing-function
   * Specifies timing function of the expand and collapse animation
   * @default linear
   */
  --ch-accordion-expand-collapse-timing-function: linear;
  /**
   * @prop --ch-accordion__header-image-size:
   * Specifies the box size that contains the start image of the header.
   * @default 0.875em
   */
  --ch-accordion__header-image-size: 0.875em;
  /**
   * @prop --ch-accordion__header-background-image-size:
   * Specifies the size of the start image of the header.
   * @default 100%
   */
  --ch-accordion__header-background-image-size: 100%;
  /**
   * @prop --ch-accordion__header-background-image-size:
   * Specifies the start image of the header.
   * @default url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>')
   */
  --ch-accordion__header-background-image: url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18" fill="none"><path d="M16.5 5L8.7 12.7L1 5" stroke="%23000" stroke-width="1.2" stroke-linecap="round"/></svg>');
  --ch-accordion-grid-template-rows: 1fr;
  display: grid;
  grid-template-rows: var(--ch-accordion-grid-template-rows);
  transition: grid-template-rows var(--ch-accordion-expand-collapse-duration) var(--ch-accordion-expand-collapse-timing-function);
  pointer-events: none;
}

.panel {
  display: grid;
  grid-template-rows: max-content 0fr;
  transition: grid-template-rows var(--ch-accordion-expand-collapse-duration) var(--ch-accordion-expand-collapse-timing-function);
  pointer-events: all;
}
.panel--expanded {
  grid-template-rows: max-content 1fr;
}

.header::after {
  content: "";
  inline-size: var(--ch-accordion__chevron-size);
  block-size: var(--ch-accordion__chevron-size);
  background-color: var(--ch-accordion__chevron-color);
  -webkit-mask: no-repeat center/var(--ch-accordion__chevron-image-size) var(--ch-accordion__header-background-image);
  transition: transform var(--ch-accordion-expand-collapse-duration) var(--ch-accordion-expand-collapse-timing-function);
}
.header--expand-button-start::after {
  order: -1;
}
.header--expand-button-start-collapsed::after {
  transform: rotate(-90deg);
}
.header--expand-button-end::after {
  margin-inline-start: auto;
}
.header--expand-button-end-expanded::after {
  transform: rotate(-180deg);
}

.header {
  --ch-accordion-header-start-img: var(--ch-start-img--base);
}
.header.start-img--hover:hover {
  --ch-accordion-header-start-img: var(--ch-start-img--hover);
}
.header.start-img--active:active {
  --ch-accordion-header-start-img: var(--ch-start-img--active);
}
.header.start-img--focus:focus {
  --ch-accordion-header-start-img: var(--ch-start-img--focus);
}
.header.start-img--disabled.ch-disabled {
  --ch-accordion-header-start-img: var(--ch-start-img--disabled);
}

.pseudo-img--start::before {
  content: "";
  display: block;
  inline-size: var(--ch-accordion__header-image-size);
  block-size: var(--ch-accordion__header-image-size);
  content-visibility: auto;
  contain-intrinsic-size: auto var(--ch-accordion__header-image-size);
}

.start-img-type--background::before {
  background: no-repeat center/var(--ch-accordion__header-background-image-size) var(--ch-accordion-header-start-img);
}

.start-img-type--mask::before {
  -webkit-mask: no-repeat center/var(--ch-accordion__header-background-image-size) var(--ch-accordion-header-start-img);
  background-color: currentColor;
}

section {
  display: grid;
  overflow: hidden;
  transition: visibility var(--ch-accordion-expand-collapse-duration) allow-discrete;
}

.section--hidden {
  visibility: hidden;
}

.sub-section {
  display: grid;
}